import { BalanceTransaction } from './types';

import { formatDateToMed } from 'helpers';
import { formatCurrency } from 'helpers/currency';

export const groupTransactionsByDay = (transactions: BalanceTransaction[]) => {
  const result = {
    regular: {} as { [key: string]: BalanceTransaction[] },
    refunds: {} as { [key: string]: BalanceTransaction[] },
  };

  transactions.forEach((transaction) => {
    const group = transaction.transaction === 'Refund' ? 'refunds' : 'regular';
    const date = transaction.date;

    if (!result[group][date]) {
      result[group][date] = [];
    }
    result[group][date].push(transaction);
  });

  return result;
};
export const isPositiveAmount = (amount: string) => amount.includes('+');

export const mapRefundTransactionToBalanceTransaction = (
  refundTransaction: any,
  currency: any,
): BalanceTransaction => {
  return {
    id: refundTransaction.uuid,
    vendor: 'Intellitix',
    date: formatDateToMed(refundTransaction.completedOn),
    createdOn: refundTransaction.completedOn,
    transaction: 'Refund',
    amount: formatCurrency(refundTransaction.refundTotalAmount / 100, currency),
    isDebit: false,
  };
};
